import {Generics} from "./generics.ts";
import {create} from "../../fjsc/src/f2.ts";

export class About {
    static page() {
        return Generics.pageFrame(
            create("div")
                .classes("flex-v", "center-items")
                .children(
                    Generics.heading(1, "About", ["bold"]),
                    Generics.paragraph("Tri Records is a place for artists to focus on their music - We handle the rest."),
                    Generics.paragraph("Artists keep 85% of the royalties."),
                    create("div")
                        .classes("flex", "center-items")
                        .children(
                            Generics.link("https://trirecords.bandcamp.com/", "Bandcamp"),
                            Generics.link("https://open.spotify.com/playlist/44rDC5pq9ueh86XAPH0OEf", "Spotify"),
                            Generics.link("https://soundcloud.com/tri-label", "Soundcloud"),
                            Generics.link("https://www.youtube.com/channel/UCoLXAcPPIGNRvKRSCFVULeQ", "Youtube"),
                        ).build(),
                    create("hr"),
                    create("div")
                        .classes("flex", "center-items", "color-dim")
                        .children(
                            Generics.paragraph("Made by "),
                            Generics.link("https://targoninc.com", "Targon Industries"),
                            Generics.paragraph("in Berlin, Germany"),
                        ).build(),
                ).build()
        );
    }
}